/* eslint-disable @cspell/spellchecker */
export const SCALE_ARMY_COMPANYID = '5e5d398c-e5e1-495b-bc0f-7236a4147784';
export const EQUITYADMIN_COMPANYID = '33d53662-2e25-48da-9448-969ec28a7c17';
export const PROD_DEMO_ACC_COMPANYID = '9a727a9b-71f9-4a3f-bd76-151467e47777';
export const PROD_DEMO_ACC_EMAIL = 'demo@getthera.com';
export const GAURAVS_PROD_COMPANYID = '1d33cea2-f814-48bf-8301-bf3dd293c77f';
export const GAURAVS_STAGING_COMPANYID = 'dc86e022-7126-48c9-b10d-01c5abd3a0a2';
export const EMAIL_DOMAINS_TO_SKIP_VERIFICATION = ['producersnational.com'];
export const THERA_PROD_COMPANY_ID = '647b17c6-60d7-49e8-8603-749d27a1af50';
export const SKIP_W9_FOR_COMPANY_ID = '60abb083-4a19-46f4-bd4e-5b555707e259';
export const SZ_COORDINATOR_USER_ID = 'user-live-f6fd0908-8d96-48e6-b46f-07b38366bbaf';
/** User IDs that skip the $50 minimum for Thera Advance withdrawals */
export const SKIP_THERA_ADVANCE_MIN_USER_IDS: string[] = ['user-live-84cc61b0-6c59-4817-9019-bc8b9a78c94d'];

/**
 * Prod pilot allow-list for the Org Chart feature. Non-prod (staging) shows the feature to everyone
 * — see `isOrgChartEnabled` in useAccessRegistry — so only production user IDs belong here. While
 * this array is non-empty, only these prod users see the org chart (button + route); empty it to
 * release the feature to all production users.
 *
 * Now empty: the org chart is released to all production users.
 */
export const ORG_CHART_PILOT_USER_IDS: string[] = [];

/**
 * Prod allow-list for the Corridor Rates settings page, which exposes provider pricing and payout
 * margins. Non-prod shows it to everyone — see `isCorridorRatesEnabled` in useAccessRegistry — so
 * only production user IDs belong here. Unlike the org-chart list, an empty array here hides the
 * page from all of production rather than releasing it: this is internal pricing data, so widening
 * access has to be deliberate.
 */
export const CORRIDOR_RATES_USER_IDS: string[] = [
  'user-live-2f59f410-feb6-4cec-aa47-d853fcae39e8', // akhil@getthera.com
  'user-live-12683c9e-751a-492a-8f13-63c7342ff33b', // sparsh@getthera.com
];

export const PAYOUT_VOLUME_USER_IDS: string[] = [
  'user-live-2f59f410-feb6-4cec-aa47-d853fcae39e8', // akhil@getthera.com
  'user-live-12683c9e-751a-492a-8f13-63c7342ff33b', // sparsh@getthera.com
];
export const PROD_SUPPORT_ZEBRA_COMPANY_ID = '292013c5-e1cf-4dd8-b012-449b5a168021';
export const SANCTIONED_REGIONS = [
  'IR', // Iran
  'SY', // Syria
  'UA', // Ukraine
  'KP', // North Korea
  'CU', // Cuba
  'VE', // Venezuela
  'BY', // Belarus
];
export const PROD_LIVE_WIRE_COMPANY_ID = 'a8e866d6-61f6-46d5-be0d-ede5d2ee890c';
export const PROD_1840_COMPANY_ID = '14eb756f-51cf-4da9-af9f-5246dde197de';
export const SKIP_2FA_EMAILS = [PROD_DEMO_ACC_EMAIL, 'sparsh@getthera.com'];
export const REFINED_SIGNS_COMPANY_ID = 'ca3f3033-d8ef-4dc8-a332-ebfd305e9d66';
export const TOURY_AI_COMPANY_ID = '269a2348-cf61-4765-a608-8d345476be91';
export const MAKE_SUBMITTING_TIMESHEETS_MANDATORY_COMPANY_ID = 'aeb66ec6-b4e6-496e-bc88-6cb8195c6a43';
export const OCEANS_COMPANY_ID = 'f30c946c-2d46-4760-a620-d2e6255a855f';
export const PORTLAND_COMMUNITY_SQUASH_COMPANY_ID = 'd1f0c377-2d16-46fb-b7ee-be43de022f8a';
/** Companies allowed to use W-2 time tracking in production; non-prod environments are not gated. */
export const TIME_TRACKING_COMPANY_IDS: string[] = [PORTLAND_COMMUNITY_SQUASH_COMPANY_ID];
export const _247VA_COMPANY_ID = 'f40da93a-64c9-45f0-85c6-3e6851df0e4b';
export const GROUPO_PACIFIC_COMPANY_ID = '833b5ddf-69c6-4bb6-856d-37c355d90960';

/**
 * List of company IDs where contractors have read-only access.
 * Contractors from these companies cannot:
 * - Edit their profile
 * - Add/edit/delete withdrawal methods
 * - Withdraw funds
 * - Create/edit/delete invoices
 * - Request or modify invoices
 * - Time off requests, time tracking,
 * - compliance documents, kyc
 *
 * They CAN:
 * - Set up 2FA (security settings)
 * - View their profile, invoices, withdrawal history, etc.
 *
 * To add a new company, simply add their company ID to this array.
 */
export const READ_ONLY_CONTRACTOR_COMPANY_IDS: string[] = [OCEANS_COMPANY_ID];
export const DISABLE_CASH_WITHDRAWAL_COMPANY_IDS: string[] = [];
export const DISABLE_WORKER_WITHDRAWAL_COMPANY_IDS: string[] = [];
// eslint-disable-next-line @cspell/spellchecker
export const ESTMERE_COMPANY_ID = 'c4f7bcd9-442e-4c21-8a86-b0feab21fac8';
export const OUTREACH_COMPANY_ID = '5e58a716-2594-4f70-8e0b-fb80a8a0eeaa';
export const SALTIRE_COMPANY_ID = '5a2f7a9d-7132-4fb3-9b09-bab0148f95c0';
export const BAAL_MANAGEMENT_COMPANY_ID = '70731594-bb89-43c2-a5cd-27747de2fe93';
export const FUNTASTIC_GYMNASTIC_COMPANY_ID = 'a05088e2-ef54-431b-b033-ded3cb6c7560';
export const DIGITAL_EXECUTIVE_COMPANY_ID = 'e1de2960-4cde-4585-9f88-b915c0d1e0f9';
export const REWORKS_SOLUTIONS_COMPANY_ID = '1d2364b2-58c7-48a0-8a66-fadf01152e8c';
export const SUPADEMO_COMPANY_ID = '4c5f44bc-16a7-414d-b3cf-2d5c23616944';

// Check Paystub 500 error company
export const CHECK_500_PAYSTUB_ERROR_COMPANY = [];

// DLocal stablecoin restrictions — block IN/LK residents and INR/LKR balance contracts
export const DLOCAL_STABLECOIN_BLOCKED_COUNTRIES: string[] = ['IN', 'LK', 'VE'];
export const DLOCAL_STABLECOIN_BLOCKED_CURRENCIES: string[] = ['INR', 'LKR', 'VES'];

// eslint-disable-next-line @cspell/spellchecker
export const KEBAB_AND_CAKE_COMPANY_ID = 'cee6759f-c8cf-45fc-998a-e102112dfd79';

// Companies that get the W2 contract step during employee onboarding
export const W2_CONTRACT_COMPANY_IDS: string[] = [GAURAVS_STAGING_COMPANYID, KEBAB_AND_CAKE_COMPANY_ID];
